import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../../components/feature/Footer';
import TableOfContents from '../../../components/feature/TableOfContents';
import ArticlePartOne from './components/ArticlePartOne';
import ArticlePartTwo from './components/ArticlePartTwo';
import ArticlePartThree from './components/ArticlePartThree';
import ArticlePartFour from './components/ArticlePartFour';

export default function CashSaleQuickClosePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    { id: 'what-makes-cash-sales-faster', title: 'What Makes Cash Sales Close So Much Faster?' },
    { id: 'why-cash-buyers-move-quickly', title: 'Why Cash Buyers Can Move So Quickly' },
    { id: 'when-cash-sale-makes-sense', title: 'When Does a Quick Cash Sale Make Sense?' },
    { id: 'understanding-cash-offers', title: 'Understanding Cash Offers: What to Expect' },
    { id: 'quick-close-process', title: 'The Quick Close Process: Step by Step' },
    { id: 'sell-house-quick-cash', title: 'Sell Your House for Quick Cash: What You Need to Know' },
    { id: 'el-paso-cash-buyers', title: 'El Paso Quick Cash Property Buyers: Finding the Right Partner' },
    { id: 'maximizing-proceeds', title: 'Maximizing Your Cash Sale Proceeds' },
    { id: 'faq', title: 'Frequently Asked Questions' },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center">
                <i className="ri-home-heart-line text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold text-gray-900">El Paso Cash Home Buyers</span>
            </Link>
            <div className="flex items-center space-x-6">
              <Link to="/" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap">Home</Link>
              <Link to="/get-cash" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap">Get Cash Offer</Link>
              <a href="tel:915-555-0100" className="bg-teal-600 text-white px-6 py-2 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap">
                Call Now
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <div className="bg-gradient-to-br from-teal-600 to-teal-700 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav aria-label="Breadcrumb" className="flex items-center space-x-2 text-teal-100 mb-4 text-sm">
            <Link to="/" className="hover:text-white transition-colors">Home</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/quick-sale" className="hover:text-white transition-colors">Quick Sale</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white font-medium">Cash Sale Quick Close</span>
          </nav>
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Cash Sales Get You a Quick Close: How to Sell Your House Fast in El Paso</h1>
          <div className="flex flex-wrap items-center gap-6 text-teal-100">
            <div className="flex items-center space-x-2">
              <i className="ri-calendar-line"></i>
              <span>Updated January 2025</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-time-line"></i>
              <span>15 min read</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-map-pin-line"></i>
              <span>El Paso, TX</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">
          {/* Table of Contents - Sidebar */}
          <aside className="lg:col-span-1">
            <TableOfContents sections={sections} />
          </aside>

          {/* Article Content */}
          <article className="lg:col-span-3 prose prose-lg max-w-none">
            <div id="what-makes-cash-sales-faster">
              <ArticlePartOne />
            </div>
            <div id="when-cash-sale-makes-sense">
              <ArticlePartTwo />
            </div>
            <div id="quick-close-process">
              <ArticlePartThree />
            </div>
            <div id="el-paso-cash-buyers">
              <ArticlePartFour />
            </div>
          </article>
        </div>
      </div>

      <Footer />
    </div>
  );
}